import { useContext, useState } from "react"
import { MainLoggedInLayout } from "../../components/layouts/main.loggedIn.layout"
import { CreatePost } from "../../components/post/CreatePost"
import { UserContext } from "../../context/UserContext"
import { Box, Button, Divider, Typography } from "@mui/material"
import { AddCircleOutline, CalendarMonth } from "@mui/icons-material"
import { useNavigate } from "react-router"

export const PostCreate = () => {
    const { userDetails } = useContext(UserContext)
    const [open, setOpen] = useState(false)
    const [status, setStatus] = useState("")
    const navigate = useNavigate()

    return (
        <MainLoggedInLayout>
            <Box sx={{ maxWidth: 480, mx: 'auto' }}>
                <Typography variant="h5" fontWeight={900} sx={{
                    mb: 3,
                    background: 'linear-gradient(90deg,#E40303,#732982)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}>
                    Create
                </Typography>

                <Box sx={{
                    borderRadius: 3,
                    background: '#fff',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                    overflow: 'hidden',
                }}>
                    <ActionRow
                        icon={<AddCircleOutline sx={{ color: '#732982' }} />}
                        label="New Post"
                        description="Share something with the community"
                        onClick={() => setOpen(true)}
                    />
                    <Divider />
                    <ActionRow
                        icon={<CalendarMonth sx={{ color: '#E40303' }} />}
                        label="Create Event"
                        description="Organize an LGBTQ+ event"
                        onClick={() => navigate("/event/create/null")}
                    />
                </Box>
            </Box>

            <CreatePost
                token={userDetails?.token}
                open={open}
                setOpen={setOpen}
                status={status}
                setStatus={setStatus}
                buttonTitle="Post"
                visibility="public"
            />
        </MainLoggedInLayout>
    )
}

const ActionRow = ({ icon, label, description, onClick }) => (
    <Button
        fullWidth
        onClick={onClick}
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            px: 2.5,
            py: 2,
            textAlign: 'left',
            textTransform: 'none',
            justifyContent: 'flex-start',
            borderRadius: 0,
            color: 'inherit',
            '&:hover': { background: 'rgba(115,41,130,0.04)' },
        }}
    >
        <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'rgba(115,41,130,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
            <Typography fontWeight={700} fontSize={14} color="#23232b">{label}</Typography>
            <Typography variant="caption" color="text.secondary">{description}</Typography>
        </Box>
    </Button>
)
